import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children, adminRequired = false }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth || !auth.currentUser) {
    // Redirect to appropriate login page based on route type
    const redirectPath = adminRequired ? '/admin' : '/login';
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  // Check admin role if required
  if (adminRequired && auth.currentUser.role !== 'admin') {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
